export default __webpack_public_path__ + "static/media/DR.SMW-black.f1ce140b.svg";